import {
  getMapSliceForColorProductId,
  getIsOnlineExclusive,
} from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/utils/productsCommonUtils';
import { parseBoolean } from '../../../../../utils';

const DELIVERY_METHODS = {
  HOME: 'home',
  BOPIS: 'bopis',
  BOSS: 'boss',
};
export const isGetSecondaryData = (fromPage, QVAccessoriesProductID, isPDP) => {
  return (
    (fromPage === 'fromPDPAccessories' || fromPage === 'fromQVAccessories') &&
    QVAccessoriesProductID?.length > 0 &&
    !isPDP
  );
};

const getIsBopisProduct = (isBopisEnabled, isBopisEligible) => {
  return isBopisEnabled && isBopisEligible;
};

const hideBopisCheck = (isOnlineExclusive, isBopisEnabled, shouldAllowOnlineProductPickup) => {
  if (shouldAllowOnlineProductPickup) {
    return !isBopisEnabled;
  }
  return isOnlineExclusive || !isBopisEnabled;
};

const getBopisAvailability = (
  currentColorEntry,
  isStoreSpecialAvailable,
  shouldAllowOnlineProductPickup
) => {
  let isOnlineExclusive;
  let isBopisEligibleFlag;
  if (currentColorEntry) {
    isBopisEligibleFlag = currentColorEntry?.miscInfo?.isBopisEligible;
    isOnlineExclusive = getIsOnlineExclusive(currentColorEntry?.miscInfo, isStoreSpecialAvailable);
  }
  if (shouldAllowOnlineProductPickup) {
    return isBopisEligibleFlag;
  }
  return !isOnlineExclusive && isBopisEligibleFlag;
};
const determineBopisFilterOn = ({
  checkForOOSForVariant,
  isBopisFilterOn,
  isStoreSpecialPriceEnabled,
  storeSpecials,
  fromBagPage,
  fromPage,
  fromStoreDetail,
}) => {
  if (checkForOOSForVariant) {
    return (
      (isBopisFilterOn || (isStoreSpecialPriceEnabled && storeSpecials)) &&
      !fromBagPage &&
      fromPage !== 'cart'
    );
  }
  if (
    (fromPage === 'StoreDetail' || parseBoolean(fromStoreDetail)) &&
    (isStoreSpecialPriceEnabled || storeSpecials)
  ) {
    return true;
  }
  return isBopisFilterOn && !fromBagPage && fromPage !== 'cart';
};

export const getPickupOptionOnInitialization = (props) => {
  const {
    isBopisFilterOn,
    isPickup,
    currentProduct: { colorFitsSizesMap },
    selectedColorProductId,
    isBopisEnabled,
    selectedPickupOption,
    setIsSTHSelected,
    fromBagPage,
    fromPage,
    isStoreSpecialPriceEnabled,
    checkForOOSForVariant,
    fromStoreDetail,
    shouldAllowOnlineProductPickup,
  } = props;
  const currentColorEntry =
    getMapSliceForColorProductId(colorFitsSizesMap, selectedColorProductId) || {};
  const { storeSpecials } = currentColorEntry;
  const isBopisEligible = getBopisAvailability(
    currentColorEntry,
    isStoreSpecialPriceEnabled && storeSpecials,
    shouldAllowOnlineProductPickup
  );
  const isBopisProduct = getIsBopisProduct(isBopisEnabled, isBopisEligible);
  const isOnlineExclusive =
    currentColorEntry?.miscInfo?.badge1?.defaultBadge &&
    currentColorEntry?.miscInfo?.badge1?.defaultBadge === 'ONLINE EXCLUSIVE' &&
    !(isStoreSpecialPriceEnabled && storeSpecials);

  const bopisFilterOn = determineBopisFilterOn({
    checkForOOSForVariant,
    isBopisFilterOn,
    isStoreSpecialPriceEnabled,
    storeSpecials,
    fromBagPage,
    fromPage,
    fromStoreDetail,
  });
  if (isPickup && selectedPickupOption) return selectedPickupOption;
  if (
    bopisFilterOn &&
    !hideBopisCheck(isOnlineExclusive, isBopisProduct, shouldAllowOnlineProductPickup)
  )
    return DELIVERY_METHODS.BOPIS;
  if (setIsSTHSelected) setIsSTHSelected(true);
  return DELIVERY_METHODS.HOME;
};

const getDeptImagePath = (departments, dpt) => {
  const temp = departments[dpt].split('-');
  const len = temp.length;
  const id = temp[len - 2];
  const pid = `${id}_${temp[len - 1]}`;
  return { pid, imagePath: `${id}/${pid}.png` || '' };
};

export const getUpdatedDepts = (departments, genderAgeGroup, prodID, seoToken) => {
  if (!departments || !prodID) {
    return {};
  }

  const id = prodID.replace(/_/g, '-');
  const depts = Object.keys(departments);

  if (!genderAgeGroup) {
    const valueExistflag = Object.values(departments).some((dpt) => dpt?.includes(id));
    if (valueExistflag) {
      return departments;
    }
    return {};
  }

  const lowerCaseGenderAgeGroup = (genderAgeGroup || '').toLowerCase();

  const filteredDpts = depts.filter((dpt) => dpt.toLowerCase().includes(lowerCaseGenderAgeGroup));

  let updatedDepartments = { ...departments };

  const flag = filteredDpts.some((dpt) => departments[dpt]?.includes(id));

  if ((!flag || filteredDpts.length === 0) && genderAgeGroup) {
    const key = `${genderAgeGroup.toUpperCase()}_${depts.length}`;
    updatedDepartments = { ...updatedDepartments, [key]: seoToken };
  }

  return updatedDepartments;
};

export const getDepartmentSwatches = (departments) => {
  const dept = Object.keys(departments);
  return dept.map((dptId) => {
    const { pid, imagePath } = getDeptImagePath(departments, dptId);
    return {
      pid,
      displayName: dptId,
      id: dptId,
      color: {
        name: dptId,
        imagePath,
      },
      imagePath,
      maximumAvailale: 9999,
    };
  });
};

export const getDepartments = (departments) => {
  const dept = Object.keys(departments);
  const finalArray = {};
  dept.forEach((currentValue) => {
    const name = currentValue.split('_')[0];
    if (!finalArray[name]) {
      finalArray[name] = { displayName: name, id: name };
    }
  }, {});

  return Object.values(finalArray);
};

export const getDepartmentsNew = (departments = []) => {
  const finalArray = {};
  departments?.forEach((currentValue) => {
    const name = currentValue;
    if (!finalArray[name]) {
      finalArray[name] = { displayName: name, id: name };
    }
  }, {});
  return Object.values(finalArray);
};

export const fetchFilteredSwatch = (swatchList = [], filter) => {
  if (filter) {
    return swatchList.filter((swatch) => swatch?.id?.indexOf(filter) > -1);
  }
  return swatchList;
};
export default {
  isGetSecondaryData,
};
